import { mapGetters } from 'vuex';

var timer=null;

export default {
    name: 'mvtToastCenter',
    inject: ['$eventBus'],
    components: {
    },
    data: function () {
        return {
            message: '',
            iconClass: '',
            visible: false,
            title: '',
            componentMounted: false,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb'])
    },
    methods: {
        reset: function () {
            this.message = '';
            this.iconClass = '';
        },
        show: function (message, iconClass, title) {
            this.reset();
            this.message = message;
            this.iconClass = iconClass;
            this.title = title;
            this.visible = true;
            if(timer){
                clearTimeout(timer);
            }
            timer = setTimeout(() => this.hide(), 5000);
        },
        hide: function () {
            this.visible = false;
        }
    },
    beforeUnmount() {
        this.$eventBus.$off('toast-center');
    },
    mounted() {
        this.componentMounted = true;
        !this.glb.isSSR &&
            this.$eventBus.$on('toast-center', (data) => {
                this.show(data.message, data.iconClass, data.title);
            });
    },
};
